function campaignProductCard() {
    document.querySelectorAll(".campaign-primary").forEach(campaignSection => {
        campaignSection.querySelectorAll(".campaign_product").forEach(product_block => {
            const visibleVariants = product_block.querySelectorAll('.campaign__image_and_card_wrapper:not(.hidden) .size-variants span.variant');
            if (visibleVariants.length > 3 ) {
                campaignProductCardManyVariantOptions(product_block, visibleVariants);
            }

            product_block.querySelectorAll(".variant").forEach(variantBtn => variantBtn.addEventListener("click", () => {
                product_block.querySelectorAll(".campaign__image_and_card_wrapper").forEach(wrapper => {
                    wrapper.classList.add("hidden")
                    if(variantBtn.dataset.blockId == wrapper.dataset.blockId){
                        wrapper.classList.remove("hidden")
                    }
                })
            }))
        })
    })
    function campaignProductCardManyVariantOptions(product_block, visibleVariants){
        let collectionHandle = null;
        const cardWrappers = product_block.querySelectorAll('.campaign__image_and_card_wrapper');
        cardWrappers.forEach((wrapper, i) => {
            const variantEls = wrapper?.querySelectorAll('.variant');
            for(let y = 3; y < variantEls.length; y++) {
                if (i > 2) break;
                variantEls[y].classList.add('hidden');
            }
            
            if (i <= 3) {
                const campaignProductCardWrapper = wrapper.querySelector('.campaign__product_card__wrapper');
                const sizeVariantEl = wrapper.querySelector('.size-variants');
                const showMoreVariantsEl = document.createElement('div');
                showMoreVariantsEl.classList.add('show_more--variants')
                const hiddenVariablesCount = visibleVariants.length - 3;
                showMoreVariantsEl.textContent = `+ ${hiddenVariablesCount} ${window.strings.more_variants}`;
                sizeVariantEl.appendChild(showMoreVariantsEl);
        
                if(campaignProductCardWrapper) {
                    if(campaignProductCardWrapper.hasAttribute('data-collection-handle')) collectionHandle = campaignProductCardWrapper.getAttribute('data-collection-handle');
                }
                if (collectionHandle) {
                    showMoreVariantsEl.addEventListener('click', function() {
                        window.location.href = window.location.origin + '/collections/' + collectionHandle;
                    })
                } else {
                    showMoreVariantsEl.addEventListener('click', () => showHiddenVariants(product_block))
                }
            }
        })
    }

    function showHiddenVariants(productBlock) {
        const showMoreBtns = productBlock.querySelectorAll('.show_more--variants');

        showMoreBtns.forEach(btn => {
            const currSizeVariantWrapper = btn.closest('div.size-variants');
            
            currSizeVariantWrapper?.querySelectorAll('span.variant.hidden')?.forEach(el => {
                el.classList.remove('hidden');
            })
            
            btn.remove();
        })
    }
}

if(document.querySelectorAll(".campaign-primary")){
    campaignProductCard();
}

document.addEventListener('quiz-offer-inserted', campaignProductCard);

